module.exports = __webpack_public_path__ + "static/media/second_2.38b7b655.jpg";